import { AxiosInstance } from 'axios';
import $ from 'jquery';
import * as React from 'react';
import { EventGroupType } from '../../Common/Constants/EventGroupType.Constants';
import HttpRequestService from '../../Services/Services.Primary/HttpService/HttpRequestService';
import { PartnerSupportService } from '../../Services/Services.Primary/HttpService/PartnerSupportService';
import { AppSessionContext } from '../../Services/Services.Primary/SessionContext/AppSessionContext';
import TelemetryService from '../../Services/Services.Primary/Telemetry/TelemetryService';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { SupportTopic } from './Models/SupportTopic';
import { Constants } from './Constants';
import { DropdownOption } from './DropdownOption';
import { DynamicDropdownOptions } from './DynamicDropdownOptions';
import { DynamicScopingQuestionURI } from './DynamicScopingQuestionURI';
import LoadingContainer from './LoadingContainer';
import { HttpResponse } from './Models/HttpServiceModels';
import { PartnerProfileData } from './Models/PartnerProfileData';
import { ScopingQuestionInfoPayload } from './Models/ScopingQuestionInfoPayload';
import { AdditionalInfo, Contact, FileInfo } from './Models/ServiceRequest';
import { RadioButtonOption } from './RadioButtonOption';
import { ScopingQuestionInfo } from './ScopingQuestionInfo';
import CountryInformationService from './Services/CountryInformationService';
import { Settings } from './Settings';
import StickyFooterView from './StickerFooter';
import { Template, TemplateApiResponse, Validation } from './Template';
import { CookieHelper } from './Utilities/CookieHelper';
import { Helper } from './Utilities/Helper';

var resx = LocalizationService.getInstance();
let Constant = Constants.getInstance();
let sessionContext = AppSessionContext.getInstance();
let tracingService = TelemetryService.getInstance();
let httpRequestService = HttpRequestService.getInstance();
let isEmptyOrSpaces = Helper.isEmptyOrSpaces;

const phoneRegex = new RegExp(Constant.getRegex.PhoneRegex);
const emailRegex = new RegExp(Constant.getRegex.EmailRegex);

// Resource strings
let Description_text = resx.getLocalizedResource('Description_text');
let Submit_text = resx.getLocalizedResource('Submit_text');
let Cancel_text = resx.getLocalizedResource('Cancel_text');
let Required_text = resx.getLocalizedResource('Required_text');
let EnterValidPhoneNumber_text = resx.getLocalizedResource('EnterValidPhoneNumber_text');
let EmailNotValid_text = resx.getLocalizedResource('EmailNotValid_text');
let MSEmailNotValid_text = resx.getLocalizedResource('MSEmailNotValid_text');
let ContactPreferences_text = resx.getLocalizedResource('ContactPreferences_text');
let RequestInfo_text = resx.getLocalizedResource('RequestInfo_text');
let ProblemSummary_text = resx.getLocalizedResource('ProblemSummary_text');
let ProblemDetails_text = resx.getLocalizedResource('ProblemDetails_text');
let DescribeYourIssue_Text = resx.getLocalizedResource('DescribeYourIssue_Text');
let ProvideAdditionalInfo_text = resx.getLocalizedResource('ProvideAdditionalInfo_text');
let DescriptionMaxExceeds_text = resx.getLocalizedResource('DescriptionMaxExceeds_text');
let Default_Option = resx.getLocalizedResource('Default_Option');
let Ticket_Title = resx.getLocalizedResource('Ticket_Title');
let DragDropText = resx.getLocalizedResource('DragDropText');
let UploadFilesText = resx.getLocalizedResource('UploadFilesText');
let PartnerTenant_LabelText = resx.getLocalizedResource('PartnerTenant_LabelText');
let MsxSeller_LabelText = resx.getLocalizedResource('MsxSeller_LabelText');
let ContactInfo_text = resx.getLocalizedResource('ContactInfo_text');
let ChangeThisInfo_text = resx.getLocalizedResource('ChangeThisInfo_text');
let AdditionalDetails_text = resx.getLocalizedResource('AdditionalDetails_text');
let AdditionalContacts_text = resx.getLocalizedResource('AdditionalContacts_text');
let AdditionalContacts_WaterMark_text = resx.getLocalizedResource('AdditionalContacts_WaterMark_text');
let EmailccListLengthLimitExceeded_Text = resx.getLocalizedResource('EmailccListLengthLimitExceeded_Text');
let EmailccListNotValid_Text = resx.getLocalizedResource('EmailccListNotValid_Text');

let countryInformationService = CountryInformationService.getInstance();
const allCountryCodes = countryInformationService.getSupportCountryCodes();

interface IFormsContainerProps {
  issueTitle: string;
  categoryOrWorkspace: string;
  issueType: SupportTopic;
  submitRequest: (
    description: string,
    primaryContact: Contact,
    workspaceId: string,
    title: string,
    attachments: any[],
    templateData: object,
    additionalInfo: AdditionalInfo[],
    countryCode: string,
    agentLocale: string,
    emailCcList: string[]
  ) => void;
  showCreateTicketError: string;
  sendingRequest: boolean;
  cancel: () => void;
  isSupportPublicRoute: boolean;
  partnerTenantId: string;
  verbatim: string;
  updateTicketTitle: (title: string) => void;
  workspaceView: boolean;
  msxSellerId: string;
}

interface IFormsContainerState {
  loading: boolean;
  resumable: { [key: string]: any };
  data: { [key: string]: any };
  attachments: FileInfo[];
  errors: { [key: string]: any };
  validationErrors: { [key: string]: any };
  showUploadProgress: boolean;
  attachFileErrorMessage: string;
  scopingQ: Template[];
  fileAttachmentHint: string;
  dynamicOptions: any;
  dynamicRadioButtonOptions: ScopingQuestionInfo;
  loadingDynamicOptions: boolean;
  templateFileUploadProgress: boolean;
  partnerProfileData: PartnerProfileData | null;
  multiSelectDropDownChevronUp: boolean;
}

interface FormDataErrorTexts {
  title: string;
  email: string;
  phoneNumber: string;
  description: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  agentLocale: string;
  emailCcList: string;
}

export enum IdStatus {
  notSet = 0,
  waiting = 1,
  set = 2,
}

export default class FormsContainer extends React.Component<IFormsContainerProps, IFormsContainerState> {
  private settings = Settings.getInstance().ClientSettings;
  private serviceHelper: AxiosInstance;
  private workspaceId: string = '';
  private isPartnerScenario = false;
  private primaryEmail = '';

  constructor(props: any) {
    super(props);
    let notificationPreferencesString = sessionStorage ? sessionStorage.getItem('NotificationPreferences') : '';
    let notificationPreferences = null;
    try {
      notificationPreferences = JSON.parse(notificationPreferencesString ?? '');
    } catch {
      notificationPreferences = null;
    }
    if (this.isPartnerScenario && notificationPreferences) {
      this.primaryEmail = notificationPreferences['contactEmail'] ? notificationPreferences['contactEmail'] : null;
    }

    this.state = {
      data: {
        templateData: {},
        title: this.props.verbatim,
        // If the user logged in to microsoft tetant but the current flow is for a partner (and not internal agent),
        // we check if the user's profile email is set to be his/her @microsoft.com address, otherwise do not prefill it
        email: '',
        phoneNumber: '',
        description: '',
        firstName: '',
        lastName: '',
        scopingQuestionsDict: {},
        countryCode: '',
        agentLocale: sessionContext.Locale,
        emailCcList: '',
      },
      resumable: {},
      loading: true,
      attachments: [],
      errors: {
        description: '',
        email: '',
        phoneNumber: '',
        title: this.props.verbatim.length > Constant.MaxTitleLength ? DescriptionMaxExceeds_text : '',
        firstName: '',
        lastName: '',
        countryCode: '',
        agentLocale: '',
        emailCcList: '',
      },
      validationErrors: {},
      showUploadProgress: false,
      attachFileErrorMessage: '',
      scopingQ: [],
      fileAttachmentHint: '',
      dynamicOptions: {},
      dynamicRadioButtonOptions: {
        answers: new Map<string, string>(),
      },
      loadingDynamicOptions: false,
      templateFileUploadProgress: false,
      partnerProfileData: null,
      multiSelectDropDownChevronUp: true,
    };

    this.serviceHelper = httpRequestService.getPublicRequestInstance();
  }

  componentDidMount() {
    this.mountAsync();
  }
  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    $('#dragdrop').on('dragover', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').addClass('dragged');
    });
    $('#dragdrop').on('dragenter', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').addClass('dragged');
    });
    $('#dragdrop').on('dragleave', function (e: any) {
      e.preventDefault();
      e.stopPropagation();
      $('#dragdrop').removeClass('dragged');
    });

    $('#dragdrop').on('drop', function (e: any) {
      e.preventDefault();
      $('#dragdrop').removeClass('dragged');
    });
  }
  private mountAsync = async () => {
    this.setState({ loading: true });
    await this.LoadScopingQsAndDynamicOptions(this.props.issueType);
    this.setState({ loading: false });
  };

  private getLoader = (showProgress: boolean) => {
    return showProgress ? <div style={{ paddingTop: '20px' }} className="upload-progress" /> : null;
  };

  private handleChange = (event: React.FormEvent<EventTarget>) => {
    let errorStore = this.state.errors;
    let data = this.state.data;
    let target = event.target as HTMLInputElement;
    data[target.name] = target.value;
    let errorMessage = '';

    if (isEmptyOrSpaces(target.value)) {
      // for form input, only email cc list is not required.
      // not setting error message for email cc list if it is empty
      if (target.name !== Constant.InputNames.EmailCcList) {
        errorMessage = Required_text;
      }
    } else if (target.name === Constant.InputNames.PhoneNumber) {
      if (!phoneRegex.test(target.value)) {
        tracingService.traceEvent(Constant.actionTypes.clientSideProblem, {
          errorMessage: 'EnterValidPhoneNumber_text',
        });
        errorMessage = EnterValidPhoneNumber_text;
      }
    } else if (target.name === Constant.InputNames.Email) {
      if (!emailRegex.test(target.value)) {
        errorMessage = EmailNotValid_text;
        tracingService.traceEvent(Constant.actionTypes.clientSideProblem, { errorMessage: 'EmailNotValid_text' });
      }
      // if the current user is logged in to microsoft tenant and the current flow is for a partner persona
      // we enforce @microsoft.com email address.
      else if (!this.validateMSEmail(target.value)) {
        errorMessage = MSEmailNotValid_text;
        tracingService.traceEvent(Constant.actionTypes.clientSideProblem, { errorMessage: 'MSEmailNotValid_text' });
      }
    } else if (target.name === Constant.InputNames.Title) {
      if (target.value.length > Constant.MaxTitleLength) {
        errorMessage = DescriptionMaxExceeds_text;
        tracingService.traceEvent(Constant.actionTypes.clientSideProblem, {
          errorMessage: 'DescriptionMaxExceeds_text',
        });
      }
      // need to inform createTicketFlowContainer on the update of ticket title so it can be prepopulated on search page if user go back there
      this.props.updateTicketTitle(target.value);
    } else if (target.name === Constant.InputNames.EmailCcList) {
      if (!this.validateEmailsInEmailCcList(target.value)) {
        errorMessage = EmailccListNotValid_Text;
      } else if (!this.validateEmailCcListLength(target.value)) {
        errorMessage = EmailccListLengthLimitExceeded_Text.replace('{0}', Constant.MaxEmailCcListLength.toString());
      }
    }

    if (errorMessage == '') {
      if (target.name === Constant.InputNames.FirstName || target.name === Constant.InputNames.LastName) {
        errorMessage = Helper.ValidateTextBoxFullRegex(target.value);
      } else {
        errorMessage = Helper.ValidateTextBoxDefault(target.value);
      }
    }
    errorStore[target.name] = errorMessage;
    this.setState({ data: data, errors: errorStore });
  };

  /**
   * Handles validation for radio button group.
   *
   * For the radio button group:
   * - has two events: onChange (actual selection of radio button), onBlur
   * -
   * - data.templateData is used for validation for submit button. Do not need to store if blur even for radio button as the radio group is is either not selected at all or has been selected from a previous change event.
   *
   * @param event
   * @param scopingQ
   */
  private handleScopingQuestionTemplateChangeForRadioButton = (
    event: React.FormEvent<EventTarget>,
    scopingQ: Template
  ) => {
    let errorStore = this.state.errors;
    let data = this.state.data;
    let target = event.target as HTMLInputElement;
    let selectedDropdownIdValue = target.id;

    if (event.type === 'change') {
      data.templateData[target.name] = target.value;
    }

    // special logic to apply to description
    if (target.id == Constant.DescriptionTemplateId) {
      let maxDescriptionLength = Helper.isCosmicTicket(this.props.issueType)
        ? Constant.MaxDescriptionLength.cosmic
        : Constant.MaxDescriptionLength.nonCosmic;
      data.description =
        target.value.length > maxDescriptionLength ? target.value.substring(0, maxDescriptionLength) : target.value;
    }

    let errorMessage = '';
    if (
      event.type === 'blur' &&
      scopingQ.required &&
      !this.isRadioButtonWithValidValue(data.scopingQuestionsDict[scopingQ.id].answers.get(scopingQ.id) ?? '')
    ) {
      errorMessage = Required_text;
    }
    errorStore[scopingQ.displayLabel] = errorMessage;
    this.setState({ errors: errorStore });

    if (event.type === 'change') {
      this.setDynamicRadioButtonOptionsDictInState(scopingQ, target.value, selectedDropdownIdValue);
    }
  };

  /**
   * Handles an event/change to a multi-select-dropdown box.
   * Refine menu item reference:
   * https://partner.microsoft.com/en-us/common/ux/docs/portalsdoc/uicomponents/components/refine-menu.html?focus=app
   *
   * If onFocus item where the display label is the text content then simply set the error message field and return.
   * onFocus is used in the href of the refine menu item for multi select drop down. please see guide link above.
   *
   * if the item is selected and the scoping question does not exist in the list of scoping questions then add, update template data, state.
   *
   * if the item already exists in scoping questions dictionary and it's answers then if the item is checked update, if the item is unchecked then delete from answers as the user has no longer chosen the answer to scoping q.
   *
   * @param: event
   * @param: scopingQ
   * @param: index // of scoping question
   */
  private handleTemplateMultiSelectDropdownChange = (
    event: React.FormEvent<EventTarget>,
    scopingQ: Template[],
    index: number
  ) => {
    let target = event.target as HTMLInputElement;
    let data = this.state.data;
    let errorStore = this.state.errors;
    errorStore[scopingQ[index].displayLabel] = '';

    // onFocus triggered by href link for refine menu item as per documentation. this is required to set 'required' text if href clicked.
    if (
      target.textContent === scopingQ[index].displayLabel &&
      scopingQ[index].required &&
      (!data.scopingQuestionsDict[scopingQ[index].id] ||
        data.scopingQuestionsDict[scopingQ[index].id].answers.size === 0)
    ) {
      errorStore[scopingQ[index].displayLabel] = Required_text;
      return;
    }

    if (!data.scopingQuestionsDict[scopingQ[index].id]) {
      let scopingQuestionInfoPayload: ScopingQuestionInfo = {
        questionDisplayText: '',
        questionId: '',
        answers: new Map(),
      };
      scopingQuestionInfoPayload.answers = new Map<string, string>();
      scopingQuestionInfoPayload.answers.set(target.id, target.textContent ?? '');
      scopingQuestionInfoPayload.questionId = scopingQ[index].id;
      scopingQuestionInfoPayload.questionDisplayText = scopingQ[index].displayLabel;
      data.scopingQuestionsDict[scopingQ[index].id] = scopingQuestionInfoPayload;
    } else {
      if (this.isChecked(target)) {
        data.scopingQuestionsDict[scopingQ[index].id].answers.set(target.id, target.textContent);
      } else {
        data.scopingQuestionsDict[scopingQ[index].id].answers.delete(target.id);
        if (data.scopingQuestionsDict[scopingQ[index].id].answers.size === 0) {
          data.templateData[scopingQ[index].displayLabel] = null;
          errorStore[scopingQ[index].displayLabel] = scopingQ[index].required ? Required_text : '';
        }
      }
    }

    data.templateData[scopingQ[index].displayLabel] = Array.from(
      data.scopingQuestionsDict[scopingQ[index].id].answers.values()
    );

    errorStore[scopingQ[index].displayLabel] =
      scopingQ[index].required &&
      (!data.scopingQuestionsDict[scopingQ[index].id] ||
        data.scopingQuestionsDict[scopingQ[index].id].answers.size === 0)
        ? Required_text
        : '';
    this.setState({ data: data, errors: errorStore });
  };

  /**
   * Gets the checked property from the input element that is hidden. This is used in the multi-select-dropdown as per UI guidelines.
   * @param target
   */
  private isChecked(target: HTMLInputElement): boolean {
    let checked = false;
    let nodes = target.offsetParent?.childNodes;

    Array.prototype.forEach.call(nodes, function (el) {
      if (el.type === 'checkbox') {
        checked = (el as HTMLInputElement).checked;
        return;
      }
    });
    return checked;
  }

  /**
   * Handles validations for input fields.
   *
   * Input field: scoping question numeric text box:
   * - If the scoping question is a numerictextbox perform seperate validation as per https://support-docs.azurewebsites.net/docs/articles/contentTypes/scopingQuestions/schema.html#validations-properties-details
   *
   * Validates each of the form fields that call this method for validation.
   *
   * @param event
   * @param scopingQ
   * @param index
   */
  private handleTemplateChange = (event: React.FormEvent<EventTarget>, scopingQ: Template[], index: number) => {
    let errorStore = this.state.errors;
    let validationErrorStore = this.state.validationErrors;
    let target = event.target as HTMLInputElement;
    var targetValue = target.value;
    let data = this.state.data;
    data.templateData[target.name] = targetValue;

    //Apply Question Id & answerId for drop down
    let selectedDropdownIdValue = '';
    if (scopingQ[index].controlType.toUpperCase() == Constant.ControlTypes.dropDown) {
      let target = event.target as HTMLSelectElement;
      selectedDropdownIdValue = target[target.selectedIndex].id ?? '';
    }

    // special logic to apply to description
    if (target.id == Constant.DescriptionTemplateId) {
      let maxDescriptionLength = Helper.isCosmicTicket(this.props.issueType)
        ? Constant.MaxDescriptionLength.cosmic
        : Constant.MaxDescriptionLength.nonCosmic;
      data.description =
        targetValue.length > maxDescriptionLength ? targetValue.substring(0, maxDescriptionLength) : targetValue;
    }

    let errorMessage = '';
    if (isEmptyOrSpaces(targetValue)) {
      if (scopingQ[index].required) {
        errorMessage = Required_text;
      }
      validationErrorStore[target.name] = '';
    } else if (
      scopingQ[index].controlType.toUpperCase() == Constant.ControlTypes.numerictextbox ||
      scopingQ[index].controlType.toUpperCase() == Constant.ControlTypes.textBox ||
      scopingQ[index].controlType.toUpperCase() == Constant.ControlTypes.multiLineTextBox
    ) {
      validationErrorStore[target.name] = this.validateNumericTextBoxOrTextBoxAndSetErrorMessage(
        target,
        scopingQ,
        index
      );
    }
    errorStore[target.name] = errorMessage;

    if (!data.scopingQuestionsDict[scopingQ[index].id]) {
      let scopingQuestionInfoPayload: ScopingQuestionInfo = {
        questionDisplayText: '',
        questionId: '',
        answers: new Map(),
      };
      scopingQuestionInfoPayload.answers = new Map<string, string>();
      scopingQuestionInfoPayload.answers.set(selectedDropdownIdValue, targetValue);
      scopingQuestionInfoPayload.questionId = scopingQ[index].id;
      scopingQuestionInfoPayload.questionDisplayText = target.name;
      data.scopingQuestionsDict[scopingQ[index].id] = scopingQuestionInfoPayload;
    } else {
      data.scopingQuestionsDict[scopingQ[index].id].answers = new Map<string, string>();
      data.scopingQuestionsDict[scopingQ[index].id].answers.set(selectedDropdownIdValue, targetValue);
    }
    this.setState({ data: data, errors: errorStore, validationErrors: validationErrorStore });
  };

  private isRadioButtonWithValidValue(valueProperty: string): boolean {
    return !isEmptyOrSpaces(valueProperty);
  }

  /**
   * Get Scoping question by given Id from the array of scoping questions.
   * @param scopingQuestions
   * @param id
   */
  private getScopingQById(scopingQuestions: Template[], id: string): Template | null {
    let scopingQ = null;
    scopingQuestions.map(scopingQuestion => {
      if (scopingQuestion.id.toUpperCase() === id.toUpperCase()) {
        scopingQ = scopingQuestion;
      }
    });
    return scopingQ;
  }

  /**
   * Get validation by given type from validations array.
   * @param validations
   * @param type
   */
  private getValidationByType(validations: Validation[], type: string): Validation | null {
    let validation = null;
    validations.map(v => {
      if (v.type.toUpperCase() === type.toUpperCase()) {
        validation = v;
      }
    });
    return validation;
  }

  private handleDateChange(event: React.FormEvent<EventTarget>, scopingQ: Template) {
    let element = event.target as HTMLInputElement;
    let dateValue = element.value;
    let data = this.state.data;
    let errorStore = this.state.errors;

    if (dateValue == null) {
      errorStore[scopingQ.displayLabel as keyof FormDataErrorTexts] = Required_text;
    } else {
      errorStore[scopingQ.displayLabel as keyof FormDataErrorTexts] = '';
    }

    data.templateData[scopingQ.displayLabel] = dateValue;

    if (!data.scopingQuestionsDict[scopingQ.id]) {
      let scopingQuestionInfoPayload: ScopingQuestionInfo = {
        questionDisplayText: '',
        questionId: '',
        answers: new Map(),
      };
      scopingQuestionInfoPayload.answers = new Map<string, string>();
      scopingQuestionInfoPayload.questionId = scopingQ.id;
      scopingQuestionInfoPayload.questionDisplayText = scopingQ.displayLabel;
      data.scopingQuestionsDict[scopingQ.id] = scopingQuestionInfoPayload;
      data.scopingQuestionsDict[scopingQ.id].answers.set(scopingQ.id, dateValue);
    } else {
      //The date picker answer is only ever one answer.
      // Therefore delete the old date entry in the dictionary and create a new k.v pair with new date picked.
      //Should only every have one entry for date picker per scoping question id!
      data.scopingQuestionsDict[scopingQ.id].answers.clear();
      data.scopingQuestionsDict[scopingQ.id].answers.set(scopingQ.id, dateValue);
    }

    data[scopingQ.displayLabel] = dateValue;
    this.setState({
      data: data,
      errors: errorStore,
    });
  }

  /**
   * Validates the textbox's or numeric textbox's value as per https://support-docs.azurewebsites.net/docs/articles/contentTypes/scopingQuestions/schema.html#validations-properties-details
   *
   * - Iterate through scoping queston validations array, if any, and validate target.value based on each validaton rule provided. The validation rule is the scoping question's validation's type and the value is the rule itself.
   * - Calls corresponding validation method.
   * - Stops further validation at the failure of the first validation rule and set's error message returned by rule/type specific validation method.
   * - Note: Can have nested validations. I.e. the validation rule of a scoping question can have a controlId that references another scoping question with the same type in it's (scoping question of id == controlId) validations array.
   *
   * @param target
   * @param scopingQ
   * @param index
   */
  private validateNumericTextBoxOrTextBoxAndSetErrorMessage(
    target: HTMLInputElement,
    scopingQ: Template[],
    index: number
  ): string {
    let errorMessage = '';
    if (scopingQ && scopingQ[index].validations) {
      scopingQ[index].validations.map(prelimValidation => {
        let validation: Validation | null = { type: '', value: '', text: '', controlId: '' };
        if (!Helper.isEmptyOrSpaces(prelimValidation.controlId)) {
          let scopingQById = this.getScopingQById(scopingQ, prelimValidation.controlId);
          if (scopingQById) {
            let validations = scopingQById.validations;
            validation = this.getValidationByType(validations, prelimValidation.type);
          }
        } else {
          validation = prelimValidation;
        }

        if (validation) {
          switch (validation.type.toUpperCase()) {
            case Constant.ValidationTypes.caseInsensitiveComparison: {
              if (target.value.toLowerCase() !== validation.value.toLowerCase()) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input value does not match case insensitive, expected value of: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.contains: {
              if (target.value.toLowerCase().indexOf(validation.value.toLowerCase()) < 0) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input value does not contain: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.notContains: {
              if (target.value.toLowerCase().indexOf(validation.value.toLowerCase()) >= 0) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input value must not contain: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.containsCharacters: {
              for (let i = 0; i < validation.value.length; ++i) {
                if (target.value.trim().search(validation.value.charAt(i)) == -1) {
                  errorMessage = validation.text
                    ? validation.text
                    : 'Input must contain following characters in any order: "' + validation.value + '"';
                  break;
                }
              }
              break;
            }
            case Constant.ValidationTypes.notContainsCharacters: {
              for (let i = 0; i < validation.value.length; ++i) {
                if (target.value.trim().search(validation.value.charAt(i)) !== -1) {
                  errorMessage = validation.text
                    ? validation.text
                    : 'Input must NOT contain following characters in any order: "' + validation.value + '"';
                  break;
                }
              }
              break;
            }
            case Constant.ValidationTypes.email: {
              if (!emailRegex.test(target.value)) {
                errorMessage = validation.text ? validation.text : 'Invalid email address';
              }
              break;
            }
            case Constant.ValidationTypes.greaterThan: {
              errorMessage = this.getIsIntErrorMessage(target) ?? '';
              if (errorMessage === null && parseInt(target.value) <= parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input value must be greater than: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.lessThan: {
              errorMessage = this.getIsIntErrorMessage(target) ?? '';
              if (errorMessage === null && parseInt(target.value) >= parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input value must be less than: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.hasLetter: {
              if (target.value.trim().search(validation.value) == -1) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input must contain following letter: "' + validation.value + '"';
                break;
              }
              break;
            }
            case Constant.ValidationTypes.hasLowerCaseLetter: {
              if (target.value.toUpperCase() === target.value) {
                errorMessage = validation.text ? validation.text : 'Input must contain at least one lower case letter';
              }
              break;
            }
            case Constant.ValidationTypes.hasUpperCaseLetter: {
              if (target.value.toLowerCase() === target.value) {
                errorMessage = validation.text ? validation.text : 'Input must contain at least one uppercase letter';
              }
              break;
            }
            case Constant.ValidationTypes.hasPunctuation: {
              if (Helper.hasPunctuation(target.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input must contain at least one off ' + Helper.getPunctuation();
              }
              break;
            }
            case Constant.ValidationTypes.minLength: {
              if (target.value.length < parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input must be at least: "' + validation.value + '"' + ' characters';
              }
              break;
            }
            case Constant.ValidationTypes.maxLength: {
              if (target.value.length > parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Input must be no more than: "' + validation.value + '"' + ' characters';
              }
              break;
            }
            case Constant.ValidationTypes.minValue: {
              errorMessage = this.getIsIntErrorMessage(target) ?? '';
              if (errorMessage === null && parseInt(target.value) < parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Value must be at least equal to: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.maxValue: {
              errorMessage = this.getIsIntErrorMessage(target) ?? '';
              if (errorMessage === null && parseInt(target.value) > parseInt(validation.value)) {
                errorMessage = validation.text
                  ? validation.text
                  : 'Value must be less than or equal to: "' + validation.value + '"';
              }
              break;
            }
            case Constant.ValidationTypes.notRegExMatch: {
              let regexp = new RegExp(validation.value);
              if (target.value.match(regexp) != null) {
                errorMessage = validation.text;
              }
              break;
            }
            case Constant.ValidationTypes.regExMatch: {
              let regexp = new RegExp(validation.value);
              if (target.value.match(regexp) === null) {
                errorMessage = validation.text;
              }
              break;
            }
          }
        }
      });
    }
    if (Helper.isEmptyOrSpaces(errorMessage)) {
      errorMessage = Helper.ValidateTextBoxDefault(target.value);
    }
    return errorMessage;
  }

  private getIsIntErrorMessage(target: HTMLInputElement) {
    return !Helper.isStringConvertableToInt(target.value) ? 'Input must be a number' : null;
  }

  /**
   * Determines whether emails in emailCcList are valid emails
   * @param emails
   */
  private validateEmailsInEmailCcList(emails: string) {
    const emailCcList = emails
      .replace(/[;\n\s]/g, ',')
      .split(',')
      .filter(Boolean);

    for (var email of emailCcList) {
      if (!emailRegex.test(email)) {
        return false;
      }
    }

    return true;
  }

  /**
   * Determines whether emailCcList length is <= 20
   * @param emails
   */
  private validateEmailCcListLength(emails: string): boolean {
    const emailCcList = emails
      .replace(/[;\n\s]/g, ',')
      .split(',')
      .filter(Boolean);
    return emailCcList.length <= Constant.MaxEmailCcListLength;
  }

  private submitRequest = () => {
    if (this.props.isSupportPublicRoute) {
      this.submitCallback();
    } else {
      if (this.state.resumable && this.state.resumable.files && this.state.resumable.files.length > 0) {
        if (
          this.state.resumable.files.filter((f: { fileName: string }) => f.fileName === '_ScopedTemplateData.json')
            .length > 0
        ) {
          this.submitCallback();
        } else {
          this.handleDataFile(); // if need to save to file, do so as a callback from upload file
        }
      } else {
        if (this.state.resumable) {
          this.handleDataFile();
        } else {
          this.submitCallback();
        }
      }
    }
    CookieHelper.set('supportCountry', this.state.data.countryCode, 90);
  };

  private handleDataFile = async () => {
    let templateFile: { [key: string]: any } = {};

    // remove empty fields
    let dataKeys = Object.keys(this.state.data.templateData);
    for (var i = 0; i < dataKeys.length; i++) {
      if (!this.state.data.templateData[dataKeys[i]]) {
        delete this.state.data.templateData[dataKeys[i]];
      }
    }
    let templateData = this.state.data.templateData;
    templateData['PartnerAccountInfo'] = {};
    templateData[Constant.BrowserInfo.browserInfo] = Helper.getBrowserInfo();

    try {
      templateFile = new File([JSON.stringify(templateData, null, 1)], Constant.PartnerSupportDataFileName);
    } catch (err) {
      // handling ie and edge
      templateFile = new Blob([JSON.stringify(templateData, null, 1)]);
      templateFile['lastModifiedDate' as keyof Blob] = new Date();
      templateFile['name'] = Constant.PartnerSupportDataFileName;
    }
    this.setState({ templateFileUploadProgress: true });
    this.state.resumable.addFile(templateFile);
  };
  private LoadScopingQsAndDynamicOptions = async (issueType: SupportTopic) => {
    let topicId: string = '';
    if (issueType.id) {
      topicId = issueType.id;
    }
    let scopingTemplatesData: { [key: string]: any };

    await PartnerSupportService.getInstance()
      .getScopingTemplatesData(topicId)
      .then(async (response: HttpResponse<TemplateApiResponse>) => {
        scopingTemplatesData = response.data;
        let scopingQ = scopingTemplatesData.form.formElements as Array<Template>;
        for (let i = 0; i < scopingQ.length; ++i) {
          let id = scopingQ[i].id;
          scopingQ[i].controlType = scopingQ[i].controlType.toUpperCase();
          switch (scopingQ[i].controlType) {
            case Constant.ControlTypes.dropDown: {
              let dynamicOptionsConfig = scopingQ[i].dynamicDropdownOptions;
              let dropdownOptionsConfig = scopingQ[i].dropdownOptions;
              if (dynamicOptionsConfig != null) {
                await this.setDynamicDropdownOptionsinState(dynamicOptionsConfig, id);
              } else if (dropdownOptionsConfig != null) {
                await this.setDropdownOptionsinState(dropdownOptionsConfig, id);
              }
              break;
            }
            case Constant.ControlTypes.radioButton: {
              await this.LoadDynamicRadioButtonOptions(scopingQ, i);
              break;
            }
            case Constant.ControlTypes.multiSelectDropDown: {
              let multiSelectDropdownOptionsConfig = scopingQ[i].dropdownOptions;
              await this.setMultiSelectDropdownOptionsInState(scopingQ, i, multiSelectDropdownOptionsConfig, id);
              break;
            }
          }
        }
        this.setState({ scopingQ: scopingQ, fileAttachmentHint: scopingTemplatesData.form.fileAttachmentHint });
      })
      .catch(error => {
        const message = error instanceof Error ? error.message : String(error);
        tracingService.traceError(`Unable to load scoping questions: ${message}`);
      });
  };

  /**
   * Follows https://partner.microsoft.com/en-us/common/ux/docs/portalsdoc/uicomponents/components/refine-menu.html?focus=app
   * Displays the items in the dropdown for selection
   * @param scopingQ
   * @param index
   * @param options
   * @param id
   */
  private setMultiSelectDropdownOptionsInState(
    scopingQ: Template[],
    index: number,
    options: Array<DropdownOption>,
    id: string
  ) {
    var dropdownOptions: any[] = [];
    options.map((option: DropdownOption) => {
      dropdownOptions.push(
        <li className="btn refine-menu-items">
          <input type="checkbox" id={option.value + '_checkbox'} name="marketRadios" />
          <span
            id={option.value}
            onClick={e => {
              this.handleTemplateMultiSelectDropdownChange(e, scopingQ, index);
            }}
          >
            {option.text}
          </span>
        </li>
      );
    });
    var currentDynamicOptions = this.state.dynamicOptions;
    currentDynamicOptions[id] = dropdownOptions;
    this.setState({ dynamicOptions: currentDynamicOptions });
  }

  /**
   * Loads the radio button options in form.
   *
   * @param scopingQ
   * @param i
   */
  private LoadDynamicRadioButtonOptions = async (scopingQ: Template[], i: number) => {
    let radioButtonOptionsConfig = scopingQ[i].radioButtonOptions;
    let id = scopingQ[i].id;
    if (radioButtonOptionsConfig != null) {
      await this.setRadioButtonOptionsInState(radioButtonOptionsConfig, id, scopingQ, i);
    }
  };

  getServiceData(uri: string) {
    return new Promise((resolve, reject) => {
      this.serviceHelper.get(uri).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  /*
   * Contract for dyanmic scoping questions currently as:
   * 1. uri:{"path": "/v1/servicerequests", "relative":true}
   * 2. uri:{"path": "<actual full APIM path here>/v1/servicerequests"; "relative": false}
   *
   * Parse the incoming URI defined in the options for the dynamic scoping questions.
   *
   * The URI path can be relative or absolute as defined by the relative tag in there.
   * The path is defined by the path tag in there.
   * */
  private getDynamicScopingQuestionsUri(optionsURI: DynamicScopingQuestionURI): DynamicScopingQuestionURI {
    let uri: DynamicScopingQuestionURI = { path: '', relative: false };
    uri.relative = optionsURI.relative;
    uri.path = !optionsURI.relative ? optionsURI.path : this.settings.PartnerApiEndpoint + optionsURI.path;
    return uri;
  }

  /*
   * The HttpResponse is of type object because the response returned from the dependency services does not have a set format that we can model.
   * TO DO: If all the dependency services exhibit a consistent model of some sort then we can try to extract the commonalities and perhaps construct a base model.
   * */
  private setDynamicDropdownOptionsinState = async (options: DynamicDropdownOptions, id: string) => {
    this.setState({ loadingDynamicOptions: true });
    let dynamicDropDownUri: DynamicScopingQuestionURI = { path: '', relative: false };
    try {
      dynamicDropDownUri = JSON.parse(options.uri);
    } catch {
      tracingService.traceError(options.uri + ' cannot be parsed in setDynamicDropdownOptionsinState');
    }
    if (!Helper.isEmptyOrSpaces(dynamicDropDownUri.path)) {
      let uri = this.getDynamicScopingQuestionsUri(dynamicDropDownUri);
      await this.getServiceData(uri.path).then(
        response => {
          let dataResponse = response as HttpResponse<object>;
          let data = dataResponse.data as { [key: string]: any };
          let dataJtokenPath = data[options.jTokenPath];
          let namePath = options.textProperty.split('/');
          let valuePath = options.valueProperty.split('/');

          var dropdownOptions: any[] = [];
          dataJtokenPath.map((path: any) => {
            var value;
            if (valuePath.length > 0) {
              value = path[valuePath[0]];
            }
            for (let i = 1; i < valuePath.length; ++i) {
              value = value[valuePath[i]];
            }

            var name;
            if (namePath.length > 0) {
              name = path[namePath[0]];
            }
            for (let i = 1; i < namePath.length; ++i) {
              name = name[namePath[i]];
            }
            dropdownOptions.push(
              <option id={value} value={name} label={name}>
                {name}
              </option>
            );
          });
          var currentDynamicOptions = this.state.dynamicOptions;
          currentDynamicOptions[id] = dropdownOptions;
          this.setState({ dynamicOptions: currentDynamicOptions });
        },
        error => {}
      );
    }
  };
  private setDropdownOptionsinState(options: Array<DropdownOption>, id: string) {
    var dropdownOptions: any[] = [];
    options.map((option: DropdownOption) => {
      dropdownOptions.push(
        <option value={option.text} id={option.value} label={option.text}>
          {option.text}
        </option>
      );
    });
    var currentDynamicOptions = this.state.dynamicOptions;
    currentDynamicOptions[id] = dropdownOptions;
    this.setState({ dynamicOptions: currentDynamicOptions });
  }

  private setRadioButtonOptionsInState(
    options: Array<RadioButtonOption>,
    id: string,
    scopingQ: Template[],
    index: number
  ) {
    let radioButtonOptions = [];
    for (let i = 0; i < options.length; i++) {
      radioButtonOptions.push(
        <div className="radio">
          <label>
            <input
              type="radio"
              name={scopingQ[index].displayLabel}
              id={options[i].value}
              value={options[i].text}
            ></input>
            <span className="text-body" style={{ color: 'black' }}>
              {options[i].text}
            </span>
          </label>
        </div>
      );
    }
    var currDynamicRadioButtonOptions: { [key: string]: any } = { ...this.state.dynamicRadioButtonOptions };
    currDynamicRadioButtonOptions[id] = radioButtonOptions;
    this.setState({ dynamicRadioButtonOptions: currDynamicRadioButtonOptions as ScopingQuestionInfo });
    this.setDynamicRadioButtonOptionsDictInState(scopingQ[index], '', '');
  }
  /**
   * - Method maintains a dictionary of radio button states to track which required ones have been set and which ones have not.
   * - target.selected is not available as each of the options for the radio group are not HTMLOptionElement because following https://partner.microsoft.com/en-us/common/ux/docs/portalsdoc/uicomponents/corecss/radios.html
   * The text property and text value are set when an onChange event is triggered for the radio button by the user! This ensures that the radio button has a value selected by the user.
   * This target value is then checked for to generate "required" error message text if radio group is not selected on blur event.
   * If blur event but this value property is set then don't need to display required error message.
   *
   * HTMLInputElement will always have a target value set when used for radio button options. Verified this. Hence, this radio button
   * state tracking.
   *
   * The first time on page load/setup the radio button based scoping questions need to be added if they are required, after that in handleTemplateChange() if the even is a change even then store radio button based scoping question into dictionary. Reason for this is that we do not want to store not required/empty radio button based scoping questions in dictionary as the API expects only filled scoping questions as per business rule.
   *
   * @param scopingQ
   * @param textProperty
   * @param valueProperty
   */
  private setDynamicRadioButtonOptionsDictInState = (scopingQ: Template, answerText: string, answerValue: string) => {
    let data = this.state.data;
    if (scopingQ.required || (!Helper.isEmptyOrSpaces(answerText) && !Helper.isEmptyOrSpaces(answerValue))) {
      if (!data.scopingQuestionsDict[scopingQ.id]) {
        let currentDynamicRadioButtonOptions: ScopingQuestionInfo = {
          questionDisplayText: '',
          questionId: '',
          answers: new Map(),
        };
        currentDynamicRadioButtonOptions.questionId = scopingQ.id;
        currentDynamicRadioButtonOptions.questionDisplayText = scopingQ.displayLabel;
        currentDynamicRadioButtonOptions.answers = new Map<string, string>();
        currentDynamicRadioButtonOptions.answers.set(scopingQ.id, answerText);
        data.scopingQuestionsDict[scopingQ.id] = currentDynamicRadioButtonOptions;
      } else if (data.scopingQuestionsDict[scopingQ.id]) {
        data.scopingQuestionsDict[scopingQ.id].answers.set(scopingQ.id, answerText);
      }
      this.setState({ data: data });
    }
  };

  private getFilesInfo = (files: any[]) => {
    let filesInfo: string[] = new Array();
    for (let fileData of files) {
      filesInfo.push(fileData.file.name + ' ' + fileData.file.type);
    }
    return filesInfo;
  };

  /**
   * Method that converts the given ScopingQuestionInfo to a ScopingQuestionInfoPayload.
   *  - A Map does not serialize to the indexed object expected as a C# Dictionary by the API controller.
   *  - Had to do this because the javascript indexed object type does not have the option to delete entries for multiple select dropdown that a user can unselect!
   *
   * @param scopingQuesionInfo
   */
  private getScopingQuestionInfoPayload(scopingQuesionInfo: ScopingQuestionInfo): ScopingQuestionInfoPayload {
    // let scopingQuestionInfoPayload: ScopingQuestionInfoPayload;
    let scopingQuestionInfoPayload: ScopingQuestionInfoPayload = {
      questionDisplayText: '',
      questionId: '',
      answers: {},
    };
    scopingQuestionInfoPayload.questionId = scopingQuesionInfo.questionId;
    scopingQuestionInfoPayload.questionDisplayText = scopingQuesionInfo.questionDisplayText;
    scopingQuestionInfoPayload.answers = {};
    scopingQuesionInfo.answers.forEach((value, key) => {
      scopingQuestionInfoPayload.answers[key] = value;
    });
    return scopingQuestionInfoPayload;
  }

  private submitCallback = () => {
    let primaryContact: Contact = {
      email: '',
      phoneNumber: '',
    };
    primaryContact.email = this.state.data.email;
    primaryContact.phoneNumber = this.state.data.phoneNumber;
    primaryContact.firstName = this.state.data.firstName;
    primaryContact.lastName = this.state.data.lastName;

    let scopingQArray = new Array();

    for (var key in this.state.data.scopingQuestionsDict) {
      let scopingQuestions: AdditionalInfo = {
        type: '',
        payLoad: {},
      };
      scopingQuestions.type = Constant.AdditionalInfoTypes.scopingQuestion;
      scopingQuestions.payLoad = this.getScopingQuestionInfoPayload(this.state.data.scopingQuestionsDict[key]);
      scopingQArray.push(scopingQuestions);
    }

    let partnerAccountInfo: AdditionalInfo = {
      type: '',
      payLoad: {},
    };
    partnerAccountInfo.type = Constant.AdditionalInfoTypes.partnerAccountInfo;
    scopingQArray.push(partnerAccountInfo);

    let browserInfo: AdditionalInfo = {
      type: '',
      payLoad: {},
    };
    browserInfo.type = Constant.AdditionalInfoTypes.browserInfo;
    browserInfo.payLoad = Helper.getBrowserInfo();
    scopingQArray.push(browserInfo);

    //split string by comma or semicolon and ignore empty values.
    let emailCcList =
      this.state.data.emailCcList &&
      this.state.data.emailCcList
        .replace(/[;\n\s]/g, ',')
        .split(',')
        .filter(Boolean);

    this.props.submitRequest(
      this.state.data.description,
      primaryContact,
      this.workspaceId,
      this.state.data.title,
      this.state.attachments,
      this.state.data.templateData,
      scopingQArray,
      this.state.data.countryCode,
      this.state.data.agentLocale,
      emailCcList
    );
  };

  private validateMSEmail(email: string): boolean {
    if (Helper.isEmptyOrSpaces(email)) {
      return false;
    }
    return true;
  }

  private validateSubmit() {
    const phoneRegex = new RegExp(Constant.getRegex.PhoneRegex);

    let data = this.state.data;
    let valid = true;

    if (
      data.email == null ||
      isEmptyOrSpaces(data.email) ||
      !emailRegex.test(data.email) ||
      !this.validateMSEmail(data.email)
    )
      valid = false;
    if (data.phoneNumber == null || isEmptyOrSpaces(data.phoneNumber) || !phoneRegex.test(data.phoneNumber))
      valid = false;
    if (data.title == null || isEmptyOrSpaces(data.title)) valid = false;
    if (data.description == null || isEmptyOrSpaces(data.description)) valid = false;
    if (isEmptyOrSpaces(data.firstName) || isEmptyOrSpaces(data.lastName)) {
      valid = false;
    }

    // loop through error message object and see if there are any non empty error messages. If so, block ticket creation
    let errors = this.state.errors;
    for (const field in errors) {
      if (!isEmptyOrSpaces(errors[field])) {
        valid = false;
        break;
      }
    }

    let scopingQ = this.state.scopingQ;
    for (let i = 0; i < scopingQ.length; ++i) {
      if (
        scopingQ[i].isVisible &&
        ((scopingQ[i].required &&
          (data.templateData[scopingQ[i].displayLabel] == null || data.templateData[scopingQ[i].displayLabel] == '')) ||
          !isEmptyOrSpaces(this.state.validationErrors[scopingQ[i].displayLabel]))
      ) {
        valid = false;
      }
    }

    if (valid && Helper.isEmptyOrSpaces(this.props.msxSellerId)) {
      valid = data.countryCode !== null && !isEmptyOrSpaces(data.countryCode);
      if (valid) {
        valid = data.agentLocale !== null && !isEmptyOrSpaces(data.agentLocale);
      }
    }
    return valid;
  }

  private isVisible = (scopingQuestionsDict: { [key: string]: ScopingQuestionInfo }, scopingVisibility: string) => {
    let visibility = scopingVisibility.split('==');
    if (scopingVisibility.indexOf('!=') != -1) {
      visibility = scopingVisibility.split('!=');
    }
    let visibilityId = visibility[0].trim();
    let visibilityValue = visibility[1].trim();
    let visible = false;

    if (scopingQuestionsDict && scopingQuestionsDict[visibilityId]) {
      for (const [key, value] of scopingQuestionsDict[visibilityId].answers.entries()) {
        if (value === visibilityValue || key === visibilityValue) {
          visible = true;
        }
      }
    }

    if (scopingVisibility.indexOf('==') != -1) {
      if (!visible) {
        // if the visibility item's value doesn't match the one user picked, then don't display this item
        return false;
      } else {
        return true;
      }
    } else {
      if (!visible) {
        // if the visibility item's value don't match the one user picked, then display this item. The statement from azure support platform is c1 != v1, in this case we display this item
        return true;
      } else {
        return false;
      }
    }
  };

  /**
   * ScopingQ[i].isVisible is used to identify if a scoping question becomes visible based on conditional visibility rules specified in the scoping question itself within the scoping template.
   *
   * Scoping question's visibility is set to false as not all of them are visible on load.
   * If a user selects a drop down that satisfies a visiblity condition for another scoping question then the visibility becomes true, i.e. visibility status is set to true as well as the scoping question becomes visible.
   * But if the scoping questions response is changed by the user and the conditionally linked scoping question's visibility rule is no longer satisfied then the scoping question's visibility is set to false as it is no longer visible.
   * */
  private LoadScopingQuestions() {
    let scopingQ = this.state.scopingQ;
    let dynamicOptions = this.state.dynamicOptions;
    let dynamicRadioButtonOptions = this.state.dynamicRadioButtonOptions;
    let newDivs = [];
    let data = this.state.data;
    for (let i = 0; i < scopingQ.length; ++i) {
      scopingQ[i].isVisible = false;
      if (
        scopingQ[i].visibility &&
        scopingQ[i].visibility != 'null' &&
        scopingQ[i].visibility.toUpperCase() != 'TRUE'
      ) {
        if (scopingQ[i].visibility.indexOf('&&') != -1) {
          // c1 == v1 && c2 == v2, statement can also be c1!=v1 && c2== v2
          let statements = scopingQ[i].visibility.split('&&');
          if (
            !(
              this.isVisible(data.scopingQuestionsDict, statements[0].trim()) &&
              this.isVisible(data.scopingQuestionsDict, statements[1].trim())
            )
          ) {
            continue;
          }
        } else if (scopingQ[i].visibility.indexOf('||') != -1) {
          // C1 == v1 || C2 == v2, statement can also be c1==v1 || c2!= v2
          let statements = scopingQ[i].visibility.split('||');
          if (
            !this.isVisible(data.scopingQuestionsDict, statements[0].trim()) &&
            !this.isVisible(data.scopingQuestionsDict, statements[1].trim())
          ) {
            continue;
          }
        } else if (!this.isVisible(data.scopingQuestionsDict, scopingQ[i].visibility)) {
          // c1==v1 or c1!=v1
          continue;
        }
      }
      let balloonTextDiv = null;
      if (scopingQ[i].infoBalloonText) {
        let infoBalloonTextDiv = scopingQ[i].infoBalloonText;
        if (scopingQ[i].infoBalloonText.indexOf('<a ') != -1) {
          infoBalloonTextDiv = scopingQ[i].infoBalloonText.split('<a ').join('<a target="_blank" ');
        }
        balloonTextDiv = (
          <div style={{ paddingTop: '10px' }}>
            <table>
              <tr>
                <td className="info-icon-cell">
                  <span className="win-icon win-icon-Info"></span>
                </td>
                <td>
                  <div className="display-inline-block" dangerouslySetInnerHTML={{ __html: infoBalloonTextDiv }} />
                </td>
              </tr>
            </table>
          </div>
        );
      }
      let validationErrorClassName: string = 'form-label';
      switch (scopingQ[i].controlType) {
        case Constant.ControlTypes.textBox: {
          scopingQ[i].isVisible = true;
          let label = scopingQ[i].displayLabel;
          let id = scopingQ[i].id;
          let ariaRequired: boolean;
          let classNameRequired: string;
          let errorClassName: string;

          if (scopingQ[i].required) {
            ariaRequired = true;
            classNameRequired = 'form-label required';
            errorClassName = 'errorMessage';
          } else {
            ariaRequired = false;
            classNameRequired = 'form-label';
            errorClassName = 'errorMessage display-none';
          }
          let inputDiv = (
            <div key={i} className="form-group col-xs-24 col-sm-14">
              <label className={classNameRequired} aria-label={label}>
                {label}
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={scopingQ[i].watermarkText ? scopingQ[i].watermarkText : ''}
                name={label}
                aria-label={label}
                aria-required={ariaRequired}
                onChange={e => this.handleTemplateChange(e, scopingQ, i)}
                onBlur={e => this.handleTemplateChange(e, scopingQ, i)}
              />
              <span className={errorClassName}>{this.state.errors[label]}</span>
              <span className={validationErrorClassName}>{this.state.validationErrors[label]}</span>
              {balloonTextDiv}
            </div>
          );

          newDivs.push(inputDiv);
          break;
        }
        case Constant.ControlTypes.numerictextbox: {
          scopingQ[i].isVisible = true;
          let label = scopingQ[i].displayLabel;
          let id = scopingQ[i].id;
          let ariaRequired: boolean;
          let classNameRequired: string;
          let errorClassName: string;
          if (scopingQ[i].required) {
            ariaRequired = true;
            classNameRequired = 'form-label required';
            errorClassName = 'errorMessage';
          } else {
            ariaRequired = false;
            classNameRequired = 'form-label';
            errorClassName = 'errorMessage display-none';
          }
          let minLimit = 'undefined';
          let maxLimit = 'undefined';
          if (scopingQ[i].validations && scopingQ[i].validations.length > 0) {
            scopingQ[i].validations.forEach((validation: Validation) => {
              if (validation.type == 'MaxValue') {
                maxLimit = validation.value;
              } else if (validation.type == 'MinValue') {
                minLimit = validation.value;
              }
            });
          }
          let inputDiv = (
            <div>
              <div className="clear"></div>
              <div key={i} className="form-group col-xs-24 col-sm-12 col-md-10 col-lg-12">
                <label className={classNameRequired} aria-label={label}>
                  {label}
                </label>
                <input
                  type="number"
                  className="form-control"
                  min={minLimit}
                  max={maxLimit}
                  placeholder={scopingQ[i].watermarkText ? scopingQ[i].watermarkText : ''}
                  name={label}
                  aria-label={label}
                  aria-required={ariaRequired}
                  onChange={e => this.handleTemplateChange(e, scopingQ, i)}
                  onBlur={e => this.handleTemplateChange(e, scopingQ, i)}
                />
                {balloonTextDiv}
                <div>
                  <span className={errorClassName}>{this.state.errors[label]}</span>
                  <span className={validationErrorClassName}>{this.state.validationErrors[label]}</span>
                </div>
              </div>
            </div>
          );
          newDivs.push(inputDiv);
          break;
        }
        case Constant.ControlTypes.dateTimePicker: {
          scopingQ[i].isVisible = true;
          let label = scopingQ[i].displayLabel;
          let id = scopingQ[i].id;
          if (!data[label]) {
            let currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            let currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
            let currentDay = currentDate.getDate();
            let currentDateFormatted = `${currentYear}-${currentMonth}-${currentDay}`;
            data[label] = currentDateFormatted;
            data.templateData[label] = currentDateFormatted;
            let scopingQuestionInfoPayload: ScopingQuestionInfo = {
              questionDisplayText: '',
              questionId: '',
              answers: new Map(),
            };
            scopingQuestionInfoPayload.answers = new Map<string, string>();
            scopingQuestionInfoPayload.questionId = scopingQ[i].id;
            scopingQuestionInfoPayload.questionDisplayText = label;
            data.scopingQuestionsDict[id] = scopingQuestionInfoPayload;
            data.scopingQuestionsDict[id].answers.set(id, data[label]);
          }
          let ariaRequired: boolean;
          let classNameRequired: string;
          let errorClassName: string;
          if (scopingQ[i].required) {
            ariaRequired = true;
            classNameRequired = 'form-label required';
            errorClassName = 'errorMessage';
          } else {
            ariaRequired = false;
            classNameRequired = 'form-label';
            errorClassName = 'errorMessage display-none';
          }
          let dateDiv = (
            <div key={i} className="form-group col-xs-24 col-sm-14">
              <label className={classNameRequired} aria-label={label}>
                {label}
              </label>
              <input
                className="form-control"
                type="date"
                value={this.state.data[label]}
                onChange={(event: React.FormEvent<EventTarget>) => this.handleDateChange(event, scopingQ[i])}
              />
              {balloonTextDiv}
              <span className={errorClassName}>{this.state.errors[label]}</span>
            </div>
          );
          newDivs.push(dateDiv);
          break;
        }
        case Constant.ControlTypes.multiLineTextBox: {
          scopingQ[i].isVisible = true;
          let label = scopingQ[i].displayLabel;
          let id = scopingQ[i].id;
          let ariaRequired: boolean;
          let classNameRequired: string;
          let errorClassName: string;
          if (scopingQ[i].required) {
            ariaRequired = true;
            classNameRequired = 'form-label required';
            errorClassName = 'errorMessage';
          } else {
            ariaRequired = false;
            classNameRequired = 'form-label';
            errorClassName = 'errorMessage display-none';
          }
          let multiLineInputDiv = (
            <div key={i} className="form-group col-xs-24 col-sm-14">
              <label className={classNameRequired} aria-label={label}>
                {label}
              </label>
              <textarea
                rows={5}
                className="form-control"
                id={id}
                name={label}
                placeholder={scopingQ[i].watermarkText ? scopingQ[i].watermarkText : ''}
                aria-label={label}
                aria-required={ariaRequired}
                onChange={e => this.handleTemplateChange(e, scopingQ, i)}
                onBlur={e => this.handleTemplateChange(e, scopingQ, i)}
              />
              {balloonTextDiv}
              <div>
                <span className={errorClassName}>{this.state.errors[label]}</span>
                <span className={validationErrorClassName}>{this.state.validationErrors[label]}</span>
              </div>
            </div>
          );
          newDivs.push(multiLineInputDiv);
          break;
        }
        case Constant.ControlTypes.infoBlock: {
          scopingQ[i].isVisible = true;
          let htmlContent = scopingQ[i].content.split('<a ').join('<a target="_blank" ');
          let infoDiv = (
            <div key={i} className="form-group col-xs-24 col-sm-14">
              <p>
                {' '}
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />{' '}
              </p>
              {balloonTextDiv}
            </div>
          );
          newDivs.push(infoDiv);
          break;
        }
        case Constant.ControlTypes.dropDown: {
          scopingQ[i].isVisible = false;
          let dynamicOptionsConfig = scopingQ[i].dynamicDropdownOptions;
          let dropdownOptionsConfig = scopingQ[i].dropdownOptions;
          let label = scopingQ[i].displayLabel;
          let id = scopingQ[i].id;
          let ariaRequired: boolean;
          let classNameRequired: string;
          let errorClassName: string;
          if (scopingQ[i].required) {
            ariaRequired = true;
            classNameRequired = 'form-label required';
            errorClassName = 'errorMessage';
          } else {
            ariaRequired = false;
            classNameRequired = 'form-label';
            errorClassName = 'errorMessage display-none';
          }
          if (dynamicOptionsConfig != null || dropdownOptionsConfig != null) {
            if (dynamicOptions[id] != null) {
              scopingQ[i].isVisible = true;
              var dynamicOptionsList = dynamicOptions[id];
              let optionsDivTemp = (
                <div key={i} className="form-group col-xs-24 col-sm-14">
                  <label className={classNameRequired} aria-label={label}>
                    {label}
                  </label>
                  <div className="combobox">
                    <select
                      id={id}
                      className="form-control"
                      name={label}
                      aria-label={label}
                      aria-required={ariaRequired}
                      onChange={e => this.handleTemplateChange(e, scopingQ, i)}
                      onBlur={e => this.handleTemplateChange(e, scopingQ, i)}
                    >
                      <option className="category-dropdown-item" disabled={true} selected={true} value="">
                        {scopingQ[i].watermarkText ? scopingQ[i].watermarkText : Default_Option}
                      </option>
                      {dynamicOptionsList}
                    </select>
                  </div>
                  {balloonTextDiv}
                  <span className={errorClassName}>{this.state.errors[label]}</span>
                </div>
              );
              newDivs.push(optionsDivTemp);
            }
          }
          break;
        }

        case Constant.ControlTypes.multiSelectDropDown: {
          this.LoadScopingQMultiSelectDropdown(scopingQ, i, dynamicOptions, newDivs, balloonTextDiv);
          break;
        }
        case Constant.ControlTypes.radioButton: {
          this.displayScopingQuestionsRadioButtonOptions(scopingQ, i, dynamicRadioButtonOptions, newDivs);
          break;
        }
      }
    }
    return newDivs;
  }

  /**
   * Follows https://partner.microsoft.com/en-us/common/ux/docs/portalsdoc/uicomponents/components/refine-menu.html?focus=app
   *
   * Displays the entire refine menu multi-select-dropdown
   *
   * @param scopingQ
   * @param i
   * @param dynamicOptions
   * @param newDivs
   * @param balloonTextDiv
   */
  private LoadScopingQMultiSelectDropdown(
    scopingQ: Template[],
    i: number,
    dynamicOptions: { [key: string]: any },
    newDivs: any[],
    balloonTextDiv: any
  ) {
    scopingQ[i].isVisible = false;
    let dynamicOptionsConfig = scopingQ[i].dynamicDropdownOptions;
    let dropdownOptionsConfig = scopingQ[i].dropdownOptions;
    let label = scopingQ[i].displayLabel;
    let id = scopingQ[i].id;
    let ariaRequired = scopingQ[i].required;
    let classNameRequired = 'form-label ' + (scopingQ[i].required ? 'required' : '');
    let errorClassName = scopingQ[i].required ? 'errorMessage' : 'errorMessage display-none';

    if (dynamicOptionsConfig != null || dropdownOptionsConfig != null) {
      if (dynamicOptions[id] != null) {
        scopingQ[i].isVisible = true;
        var dynamicOptionsList = dynamicOptions[id];
        let optionsDivTemp = (
          <div key={i} className="form-group col-xs-24 col-sm-14">
            <aside className="refine-menu">
              <div className="refine-menu-category" style={{ paddingTop: '0px', border: '0px' }}>
                <header className="refine-menu-subheader refine-menu-subheader-border">
                  <a
                    className="refine-menu-collapse"
                    data-toggle="collapse"
                    data-collapse-icon="win-icon-ChevronUp"
                    data-expand-icon="win-icon-ChevronDown"
                    aria-expanded="false"
                    aria-controls="collapseMarket"
                    href="#collapseMarket"
                    onClick={event => {
                      this.toggleChevronUpChevronDown();
                    }}
                    onFocus={e => {
                      this.handleTemplateMultiSelectDropdownChange(e, scopingQ, i);
                    }}
                    aria-required={ariaRequired}
                  >
                    <h3 className="refine-menu-subtitle" aria-label={label}>
                      {label}
                      <label className={classNameRequired}></label>
                    </h3>
                    <span
                      className={
                        this.state.multiSelectDropDownChevronUp
                          ? 'win-icon win-icon-ChevronUp refine-menu-icon'
                          : 'win-icon win-icon-ChevronDown  refine-menu-icon'
                      }
                    ></span>
                  </a>
                </header>
                <ul
                  className="refine-menu-items collapse in refine-menu-subheader-border"
                  id="collapseMarket"
                  data-toggle="buttons"
                  aria-required={ariaRequired}
                >
                  {dynamicOptionsList}
                </ul>
                <div className={errorClassName}>{this.state.errors[label]}</div>
                {balloonTextDiv}
              </div>
            </aside>
          </div>
        );
        newDivs.push(optionsDivTemp);
      }
    }
  }

  /**
   * if state has been changed to chevron up, it means that the drop down has been requested to expand/show
   * */
  private toggleChevronUpChevronDown = () => {
    this.setState({ multiSelectDropDownChevronUp: !this.state.multiSelectDropDownChevronUp });
    let element = document.getElementById('collapseMarket');
    element?.classList.toggle('hide');
  };

  private displayScopingQuestionsRadioButtonOptions(
    scopingQ: Template[],
    i: number,
    dynamicRadioButtonOptions: any,
    newDivs: any[]
  ): void {
    scopingQ[i].isVisible = false;
    let dynamicRadioButtonOptionsConfig = scopingQ[i].dynamicRadioButtonOptions;
    let radioButtonOptionsConfig = scopingQ[i].radioButtonOptions;
    let label = scopingQ[i].displayLabel;
    let id = scopingQ[i].id;
    let ariaRequired: boolean;
    let classNameRequired: string;
    let errorClassName: string;
    if (scopingQ[i].required) {
      ariaRequired = true;
      classNameRequired = 'form-label required';
      errorClassName = 'errorMessage';
    } else {
      ariaRequired = false;
      classNameRequired = 'form-label';
      errorClassName = 'errorMessage display-none';
    }
    if (dynamicRadioButtonOptionsConfig != null || radioButtonOptionsConfig != null) {
      if (dynamicRadioButtonOptions[id] != null) {
        scopingQ[i].isVisible = true;
        var dynamicRadioButtonOptionsList = dynamicRadioButtonOptions[id];
        let optionsDivTemp = (
          <div key={i} className="form-group col-xs-24 col-sm-14">
            <fieldset
              role="radiogroup"
              style={{ color: 'black' }}
              aria-label={label}
              aria-required={ariaRequired}
              onChange={e => this.handleScopingQuestionTemplateChangeForRadioButton(e, scopingQ[i])}
              onBlur={e => this.handleScopingQuestionTemplateChangeForRadioButton(e, scopingQ[i])}
            >
              <label className={classNameRequired} aria-label={label} aria-required={ariaRequired}>
                {label}
              </label>
              {dynamicRadioButtonOptionsList}
            </fieldset>
            <span className={errorClassName}>{this.state.errors[label]}</span>
          </div>
        );
        newDivs.push(optionsDivTemp);
      }
    }
  }

  private isValidStatePartnerProfileCountryCode = () => {
    return (
      this.state.partnerProfileData !== null &&
      !isEmptyOrSpaces(this.state.partnerProfileData.support.support.locale) &&
      countryInformationService.getSupportCountryLocalizedName(this.state.partnerProfileData.support.support.locale) !==
        null &&
      !isEmptyOrSpaces(
        countryInformationService.getSupportCountryLocalizedName(this.state.partnerProfileData.support.support.locale)
      )
    );
  };
  /*
   * Ticket is either SD or Cosmic.
   * */
  private LoadCountryRegionDropDownList = (CountryRegion_LabelText: string) => {
    const label = 'countryCode';
    let dropdownOptions = [];
    let country: string;
    let required = Helper.isEmptyOrSpaces(this.props.msxSellerId);

    if (this.isValidStatePartnerProfileCountryCode()) {
      dropdownOptions.push(
        <option
          value={this.state.partnerProfileData?.support.support.locale}
          label={countryInformationService.getSupportCountryLocalizedName(
            this.state.partnerProfileData?.support.support.locale ?? ''
          )}
        >
          {countryInformationService.getSupportCountryLocalizedName(
            this.state.partnerProfileData?.support.support.locale ?? ''
          )}
        </option>
      );
      required = false;
    }

    for (let index in allCountryCodes) {
      const code = allCountryCodes[index];
      country = countryInformationService.getSupportCountryLocalizedName(code);
      dropdownOptions.push(
        <option value={code} label={country}>
          {country}
        </option>
      );
    }

    let displayDefaultOption = !this.isValidStatePartnerProfileCountryCode() ? (
      <option value="" disabled={true} selected={true}>
        {Default_Option}
      </option>
    ) : (
      ''
    );
    return (
      <div className="form-group col-xs-24 col-sm-14 remove-top-margin">
        <label className="form-label required">{CountryRegion_LabelText}</label>
        <div className="combobox">
          <select
            id="CountryRegionSelectId"
            className="form-control"
            name={label}
            aria-label={CountryRegion_LabelText}
            aria-required={required}
            onChange={this.handleChange}
            onBlur={this.handleChange}
            onFocus={this.handleChange}
            onMouseOver={this.handleChange}
          >
            {displayDefaultOption}
            {dropdownOptions}
          </select>
          <span className="errorMessage">{this.state.errors.countryCode}</span>
        </div>
      </div>
    );
  };

  private isValidStatePartnerProfileLanguage = (supportedLanguages: { [key: string]: any }) => {
    return (
      this.state.partnerProfileData !== null &&
      !isEmptyOrSpaces(this.state.partnerProfileData.notifications.preferredEmailLanguage) &&
      supportedLanguages[this.state.partnerProfileData.notifications.preferredEmailLanguage] !== null &&
      !isEmptyOrSpaces(supportedLanguages[this.state.partnerProfileData.notifications.preferredEmailLanguage])
    );
  };

  private LoadLanguagesDropDownList = (Language_LabelText: string) => {
    const id = 'languageSelectId';
    const label = 'agentLocale';
    let dropdownOptions = [];
    let supportedLanguages: { [key: string]: any } = countryInformationService.getSupportedLanguagesList();
    let required = Helper.isEmptyOrSpaces(this.props.msxSellerId);

    if (this.isValidStatePartnerProfileLanguage(supportedLanguages)) {
      dropdownOptions.push(
        <option
          value={this.state.partnerProfileData?.notifications.preferredEmailLanguage}
          label={supportedLanguages[this.state.partnerProfileData?.notifications.preferredEmailLanguage ?? '']}
        >
          {supportedLanguages[this.state.partnerProfileData?.notifications.preferredEmailLanguage ?? '']}
        </option>
      );
      required = false;
    }

    Object.keys(supportedLanguages).map(function (key) {
      let language = supportedLanguages[key];
      dropdownOptions.push(
        <option value={key} label={language}>
          {language}
        </option>
      );
    });

    let displayDefaultOption = !this.isValidStatePartnerProfileLanguage(supportedLanguages) ? (
      <option value="" disabled={true} selected={true}>
        {Default_Option}
      </option>
    ) : (
      ''
    );
    return (
      <div className="form-group col-xs-24 col-sm-14">
        <label className="form-label required">{Language_LabelText}</label>
        <div className="combobox">
          <select
            id={id}
            className="form-control"
            name={label}
            aria-label={Language_LabelText}
            aria-required={required}
            onChange={this.handleChange}
            onBlur={this.handleChange}
            onFocus={this.handleChange}
            onMouseOver={this.handleChange}
          >
            {displayDefaultOption}
            {dropdownOptions}
          </select>
          <span className="errorMessage">{this.state.errors.agentLocale}</span>
        </div>
      </div>
    );
  };

  private cancelCreateTicket = () => {
    let eventName = Constant.actionTypes.detailsCancel;
    tracingService.traceEvent(eventName, {}, EventGroupType.ticketCreation);
    this.props.cancel();
  };

  private getButtonDivForFooter = (sendingRequest: boolean) => {
    return (
      <div className="sticky-footer-buttons">
        <button
          className="btn-primary"
          onClick={this.submitRequest}
          disabled={!this.validateSubmit() || sendingRequest || this.state.templateFileUploadProgress}
        >
          {Submit_text}
        </button>
        <button
          style={{ marginLeft: '5px', marginRight: '5px' }}
          disabled={sendingRequest || this.state.templateFileUploadProgress}
          onClick={this.cancelCreateTicket}
        >
          {Cancel_text}
        </button>
        <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          {this.getLoader(sendingRequest || this.state.templateFileUploadProgress)}
        </div>
      </div>
    );
  };

  private getRemainingCharacters = () => {
    return 255 - (this.state.data.title ? this.state.data.title.length : 0);
  };
  public render() {
    let { showCreateTicketError, sendingRequest } = this.props;
    let maxDescriptionLength = Helper.isCosmicTicket(this.props.issueType)
      ? Constant.MaxDescriptionLength.cosmic
      : Constant.MaxDescriptionLength.nonCosmic;

    // TODO: These are done inside, because when done outside these are fetched before loggedinPersona is being modified in app.tsx. we can move these back above once loggined user and persona are set in server side
    const Email_text = resx.getLocalizedResource('YourEmail_text');
    const PhoneNumber_text = resx.getLocalizedResource('YourPhoneNumber_text');
    const FirstName_LabelText = resx.getLocalizedResource('FirstName_LabelText');
    const LastName_LabelText = resx.getLocalizedResource('LastName_LabelText');
    const CountryRegion_LabelText = resx.getLocalizedResource('CountryRegion_Text');
    const Language_LabelText = resx.getLocalizedResource('PreferredLanguage_Text');

    const containerClass = this.props.workspaceView ? 'win-color-bg-0' : 'win-color-bg-0 spacer-md-left';
    let display = (
      <div>
        <div className="flexShrink0">
          <div className={containerClass}>
            <div style={{ paddingTop: '15px', paddingBottom: '50px', paddingLeft: '24px', paddingRight: '24px' }}>
              <section className="section" style={{ marginBottom: '44px' }}>
                <header className="section-header" style={{ marginBottom: '20px' }}>
                  <h5 className="section-title">{RequestInfo_text}</h5>
                </header>
                <div role="form">
                  <div className="row">
                    <div className="form-group col-xs-24 col-sm-14 remove-top-margin">
                      <label className="form-label required">{ProblemSummary_text}</label>{' '}
                      <span className="floatRight" id="problemSummaryRemainingCharacters">
                        {this.getRemainingCharacters()}
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="problemSummary"
                        name="title"
                        placeholder={DescribeYourIssue_Text}
                        aria-label={Ticket_Title}
                        aria-required="true"
                        value={this.state.data.title}
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                        maxLength={Constant.MaxTitleLength}
                      />
                      <span className="errorMessage">{this.state.errors.title}</span>
                    </div>
                    <div className="clear"></div>
                    {!(this.state.scopingQ && this.state.scopingQ.length > 0) && (
                      <div className="form-group col-xs-24 col-sm-14">
                        <label className="form-label required">{ProblemDetails_text}</label>
                        <div className="input-counter" data-toggle="input-counter">
                          <textarea
                            rows={5}
                            id="description"
                            name="description"
                            placeholder={ProvideAdditionalInfo_text}
                            aria-label={Description_text}
                            aria-required="true"
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                            maxLength={maxDescriptionLength}
                          ></textarea>
                          <span className="errorMessage">{this.state.errors.description}</span>
                        </div>
                      </div>
                    )}
                    <div className="clear"></div>
                    {!this.props.isSupportPublicRoute && (
                      <div id="pxsupport-upload" className="form-group col-xs-24 col-sm-14">
                        <div className="img-uploader" id="uploader">
                          <div className="block-col no-reqs">
                            <label className="form-label">
                              {!isEmptyOrSpaces(this.state.fileAttachmentHint)
                                ? this.state.fileAttachmentHint
                                : UploadFilesText}
                            </label>
                            <div className="block win-color-bg-20" id="dragdrop">
                              {this.state.attachments &&
                                this.state.attachments.length > 0 &&
                                this.state.attachments.map((attachment: FileInfo) => {
                                  // check against 0 due to \0 SOMETIMES appearing and making the equality check fail
                                  if (
                                    attachment.fileNameWithoutExtension &&
                                    attachment.fileNameWithoutExtension.indexOf(Constant.PartnerSupportDataFileName) !=
                                      0
                                  ) {
                                    return <p>{attachment.fileNameWithoutExtension}</p>;
                                  } else {
                                    return null;
                                  }
                                })}
                              {(() => {
                                if (this.state.attachFileErrorMessage && this.state.attachFileErrorMessage.length > 0) {
                                  return <p style={{ color: 'red' }}>{this.state.attachFileErrorMessage}</p>;
                                }
                              })()}
                              {this.getLoader(this.state.showUploadProgress)}
                              <div className="description" id="browseButton">
                                <span className="icon-win-CloudUpload dev-icon"></span>
                                <button
                                  style={{ fontWeight: 'bold', paddingLeft: '3px', paddingRight: '3px' }}
                                  className="btn-link"
                                  id="DragDropTextId"
                                  data-toggle="tab"
                                >
                                  {DragDropText}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
              {this.state.scopingQ && this.state.scopingQ.length > 0 && (
                <section className="section" style={{ marginBottom: '44px' }}>
                  <header className="section-header" style={{ marginBottom: '0' }}>
                    <h5 className="section-title">{AdditionalDetails_text}</h5>
                  </header>
                  <div role="form">
                    <div className="row">
                      <div>
                        {this.LoadScopingQuestions().map((div: any, i: number) => {
                          return <div key={i}>{div}</div>;
                        })}
                      </div>
                    </div>
                  </div>
                </section>
              )}
              <section className="section" style={{ marginBottom: '44px' }}>
                <header className="section-header" style={{ marginBottom: '0' }}>
                  <h5 className="section-title">{ContactInfo_text}</h5>
                </header>
                <div role="form">
                  <div className="row">
                    {this.isPartnerScenario && !Helper.isEmptyOrSpaces(this.primaryEmail) && (
                      <div className="form-group col-xs-24 col-sm-14">
                        <div dangerouslySetInnerHTML={{ __html: ChangeThisInfo_text }}></div>
                      </div>
                    )}
                    <div className="clear"></div>
                    {!this.isPartnerScenario && !Helper.isEmptyOrSpaces(this.props.partnerTenantId) && (
                      <>
                        <div className="form-group col-xs-24 col-sm-14">
                          <label className="form-label">{PartnerTenant_LabelText}: </label>
                          <div>{this.props.partnerTenantId}</div>
                        </div>
                        <div className="clear"></div>
                      </>
                    )}
                    {!this.isPartnerScenario && !Helper.isEmptyOrSpaces(this.props.msxSellerId) && (
                      <>
                        <div className="form-group col-xs-24 col-sm-14">
                          <label className="form-label">{MsxSeller_LabelText}: </label>
                          <div>{this.props.msxSellerId}</div>
                        </div>
                        <div className="clear"></div>
                      </>
                    )}
                    <div className="form-group">
                      <div className="col-xs-12 col-sm-7">
                        <label className="form-label required">{FirstName_LabelText}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="firstName"
                          value={this.state.data.firstName}
                          aria-label={FirstName_LabelText}
                          aria-required="true"
                          onChange={this.handleChange}
                          onBlur={this.handleChange}
                        />
                        <span className="errorMessage">{this.state.errors.firstName}</span>
                      </div>
                      <div className="col-xs-12 col-sm-7">
                        <label className="form-label required">{LastName_LabelText}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="lastName"
                          value={this.state.data.lastName}
                          aria-label={LastName_LabelText}
                          aria-required="true"
                          onChange={this.handleChange}
                          onBlur={this.handleChange}
                        />
                        <span className="errorMessage">{this.state.errors.lastName}</span>
                      </div>
                    </div>
                    <div className="clear"></div>
                    <div className="form-group col-xs-24 col-sm-14">
                      <label className="form-label required">{PhoneNumber_text}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="phoneNumber"
                        aria-label={PhoneNumber_text}
                        aria-required="true"
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                      />
                      <span className="errorMessage">{this.state.errors.phoneNumber}</span>
                    </div>
                    <div className="clear"></div>
                    <div className="form-group col-xs-24 col-sm-14">
                      <label className="form-label required">{Email_text}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        aria-label={Email_text}
                        aria-required="true"
                        value={this.state.data.email}
                        onChange={this.handleChange}
                        onBlur={this.handleChange}
                      />
                      <span className="errorMessage">{this.state.errors.email}</span>
                    </div>
                    {(() => {
                      if (this.props.issueType && !Helper.isCosmicTicket(this.props.issueType)) {
                        return (
                          <div>
                            <div className="clear"></div>
                            <div className="form-group col-xs-24 col-sm-14">
                              <label className="form-label">{AdditionalContacts_text}</label>
                              <div className="input-counter" data-toggle="input-counter">
                                <textarea
                                  rows={3}
                                  id="emailccList"
                                  name="emailCcList"
                                  placeholder={AdditionalContacts_WaterMark_text}
                                  aria-label={AdditionalContacts_text}
                                  onChange={this.handleChange}
                                  onBlur={this.handleChange}
                                  maxLength={maxDescriptionLength}
                                ></textarea>
                                <span style={{ color: 'red' }}>{this.state.errors.emailCcList}</span>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })()}
                  </div>
                </div>
              </section>

              {Helper.isEmptyOrSpaces(this.props.msxSellerId) && (
                <section className="section" style={{ marginBottom: '44px' }}>
                  <header className="section-header">
                    <h5 className="section-title">{ContactPreferences_text}</h5>
                  </header>
                  <div role="form">
                    <div className="row">
                      {this.LoadCountryRegionDropDownList(CountryRegion_LabelText)}

                      <div className="clear"></div>
                      {this.LoadLanguagesDropDownList(Language_LabelText)}
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
        <div
          className="paddingBottom24"
          style={this.props.workspaceView ? { margin: '0px' } : { marginLeft: '24px', marginRight: '24px' }}
        >
          {(() => {
            if (!Helper.isEmptyOrSpaces(showCreateTicketError)) {
              tracingService.traceEvent(Constant.actionTypes.clientSideProblem, {
                errorMessage: 'CannotSubmitRequestError_text',
              });
              return (
                <div className="col-xs-24">
                  <p style={{ color: 'red' }}>{showCreateTicketError}</p>
                </div>
              );
            }
          })()}
          <StickyFooterView ButtonsDiv={this.getButtonDivForFooter(sendingRequest)} />
        </div>
      </div>
    );
    return <LoadingContainer showProgress={this.state.loading} display={display}></LoadingContainer>;
  }
}
